import React from 'react';
import { ScrollView, View } from 'react-native';

import { isNil as _isNil } from 'lodash';
import PropTypes from 'prop-types';

import {
  FilterBar,
  SectionHeader,
  VFScreen,
  ErrorScreen,
} from '@vfgroup-oneplatform/foundation/Components';
import { LightThemeColors, useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { useProductsCategoriesFilter } from '../../../Utils/Hooks';
import { AddOnsShopLoading } from '../../Components';
import AddOnsList from '../../Components/AddOnsList';

import styles from './AddOnsShop.Styles';

const AddOnsShop = ({
  vfScreenProps,
  onItemPress,
  addOns: addOnsItems,
  isLoading,
  error,
  images,
  onTryAgainPress,
  title,
  isCurrencyFirst,
}) => {
  const theme = useTheme();
  const {
    products: addOns,
    selectedCategories,
    categories,
    onSelectedCategoriesChange,
  } = useProductsCategoriesFilter(addOnsItems);

  const renderError = () => {
    return (
      <ErrorScreen
        text={error?.message}
        {...error}
        onPress={onTryAgainPress}
        textButton={'soho_addons_shop_addons_error_try_again'}
        backgroundStyle={styles.errorBackgroundStyle}
      />
    );
  };

  const renderAddOnsData = () => {
    return (
      <>
        <FilterBar
          filterData={categories}
          selectedCategories={selectedCategories}
          setSelectedCategories={onSelectedCategoriesChange}
        />

        <View style={styles.dividerContainer}>
          <View style={styles.divider(theme)} />
        </View>

        <View style={styles.addOnsListContainer}>
          <AddOnsList
            withUsers={false}
            data={addOns}
            images={images}
            onAddOnPress={onItemPress}
            isCurrencyFirst={isCurrencyFirst}
          />
        </View>
      </>
    );
  };

  const renderLoading = () => {
    return <AddOnsShopLoading />;
  };

  const renderContent = () => {
    return (
      <ScrollView contentContainerStyle={styles.scrollViewContentContainerWithTray}>
        <SectionHeader
          style={styles.sectionHeader}
          title={title}
          titleStyle={styles.titleStyle}
          subtitle={'soho_addons_shop_addons_subtitle_add_more_addons'}
          subtitleStyle={styles.subTitleStyle}
        />
        {renderAddOnsData()}
      </ScrollView>
    );
  };

  const isError = !_isNil(error);

  return (
    <VFScreen
      title={'soho_addons_shop_addons_screen_title'}
      {...vfScreenProps}
      headerStyle={isError ? styles.errorHeaderStyle : null}
      statusBarProps={isError ? styles.statusBarStyle : null}
    >
      {isLoading ? renderLoading() : isError ? renderError() : renderContent()}
    </VFScreen>
  );
};

AddOnsShop.defaultProps = {
  theme: LightThemeColors,
  title: 'soho_addons_shop_addons_title_shop_addons',
  isCurrencyFirst: false,
};

AddOnsShop.propTypes = {
  vfScreenProps: PropTypes.shape({
    onBack: PropTypes.func,
    showBack: PropTypes.bool,
    showClose: PropTypes.bool,
  }),
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  onBack: PropTypes.func,
  onItemPress: PropTypes.func,
  addOns: PropTypes.array,
  isLoading: PropTypes.bool,
  error: PropTypes.shape({
    message: PropTypes.string,
  }),
  images: PropTypes.object,
  onTryAgainPress: PropTypes.func,
  title: PropTypes.string,
  isCurrencyFirst: PropTypes.bool,
};

export default AddOnsShop;
